export function formatLastActive(lastActive, locale, timeZone) {
  if( !lastActive ) return 'Never';

  const date = new Date(lastActive);
  if( Number.isNaN(date.getTime()) ) return 'Never';

  return new Intl.DateTimeFormat(locale, {
    year         : 'numeric',
    month        : 'short',
    day          : '2-digit',
    hour         : 'numeric',
    minute       : '2-digit',
    second       : '2-digit',
    timeZoneName : 'short',
    ...(timeZone ? { timeZone } : {}),
  }).format(date);
}
